import React, { useState, useEffect, useContext } from 'react'
import NoDataError from '../../components/NoDataError';
import * as ServiceWatchAPI from '../../services/serviceWatchService'
import ServiceWatchTr from '../../components/ServiceWatchTr';
import { useNavigate, useParams } from 'react-router-dom';
import { ServiceWatchListContext } from '../../layout/BaseLayout';

const ServiceWatch = () => {

    let serviceWatchList = useContext(ServiceWatchListContext);

    const [licenceList, setLicenceList] = useState({});
    const [selectedLicence, setSelectedLicence] = useState("");
    const [filteredWhiteLabel, setFilteredWhiteLabel] = useState([]);
    const [selectedWhiteLabel, setSelectedWhiteLabel] = useState("");
    const [selectDomain, setSelectDomain] = useState("");
    const [servicesList, setServicesList] = useState([]);
    const [updatedServiceList, setUpdatedServiceList] = useState([]);

    const navigate = useNavigate();
    const paramId = useParams();

    useEffect(() => {
        if (serviceWatchList?.length > 0 && servicesList?.length > 0) {
            let mergedArray = serviceWatchList?.map((item) => {
                servicesList.forEach((itm) => {
                    if (item?.ServiceName === itm.caption) {
                        item = { ...item, status: itm.status, name: itm.name };
                    }
                });
                return item
            })
            setUpdatedServiceList(mergedArray)
        }
        else {
            setUpdatedServiceList(serviceWatchList)
        }
    }, [servicesList])

    useEffect(() => {
        if (!!selectedWhiteLabel) {
            updateSelectedDomain(null, selectedWhiteLabel);
        }
    }, [selectedWhiteLabel]);

    useEffect(() => {
        filterWhiteLabelOptions();
        setSelectedWhiteLabel("");
    }, [selectedLicence]);

    useEffect(() => {
        getAllLicence();
    }, [])

    useEffect(() => {
        getAllLicence();
    }, [paramId])

    const getAllServiceStatus = (val) => {
        ServiceWatchAPI.getAllServiceIISAndWindows(val).then((res) => {
            if (res.isSuccess) {
                setServicesList(res.data);
            } else {
                setServicesList([]);
            }
        })
    }

    const getAllLicence = () => {
        ServiceWatchAPI.getLicenceAndWhiteLabelList().then((res) => {
            if (res.isSuccess) {
                const groupLicenceMaster = res?.data?.reduce((groups, item) => {
                    const opcode = item.operatorId;
                    if (!groups[opcode]) {
                        groups[opcode] = { itm: [], displayName: null };
                    }
                    groups[opcode].itm.push(item);
                    if (!item?.parentCompanyName) {
                        groups[opcode].displayName = `${item?.operatorId} - ${item?.companyName}`
                    }
                    return groups;
                }, {})
                setLicenceList(groupLicenceMaster);
            }
        })
    }

    const filterWhiteLabelOptions = () => {
        if (selectedLicence) {
            const licenceItems = licenceList[selectedLicence]?.itm || [];
            const filteredItems = licenceItems.filter(
                (item) => item.operatorId === selectedLicence && item.whiteLabel
            );
            setFilteredWhiteLabel(filteredItems);
        } else {
            setFilteredWhiteLabel([]);
        }
    };

    const updateSelectedDomain = (evnt, val) => {
        if (val) {
            setSelectDomain(val);
        } else
            if (evnt) {
                const licenceItems = licenceList[evnt]?.itm;
                const domainItem = licenceItems.find(
                    (item) => item.operatorId === evnt && !item.whiteLabel
                );
                setSelectDomain(domainItem?.primaryDomain);
            }
    };

    const onChangeOfLicence = (e) => {
        setSelectedLicence(e.target.value);
        updateSelectedDomain(e.target.value, null);
        // setServicesList([]);
        getAllServiceStatus(e.target.value);
    }

    const onChangeOfWhiteLable = (e) => {
        setSelectedWhiteLabel(e.target.value);
    }

    const regetservices = () => {
        getAllServiceStatus(selectedLicence);
    }

    useEffect(() => {
        if (!!paramId && Object.keys(licenceList)?.length > 0) {
            setSelectedLicence(paramId.id);
            updateSelectedDomain(paramId.id, null);
            getAllServiceStatus(paramId.id);
        }
    }, [paramId, licenceList])

    return (
        <div id='tabs'>
            <div className="maintitle-box">
                <div className="w-50 d-inline-block">
                    <h2 className="maintitle "><img className="main-title-img" src={"/images/svg/service-watch.svg"} alt="" />Service Watch</h2>
                </div>
            </div>
            <div className='mt-2 mb-3 px-3'>
                <div className='d-flex align-items-center'>
                    <div className='client-po-id text-right mr-2'>Licence:</div>
                    <div className=''>
                        <select className='w-250 form-select inputborder font11' value={selectedLicence} onChange={(e) => { onChangeOfLicence(e); }}>
                            <option value="">Select</option>
                            {Object.entries(licenceList).map(([key, item]) => {
                                return (
                                    <option className={`${!item?.itm[0]?.licenseStatus && "dropdown-bg-color"}`} disabled={!item?.itm[0]?.licenseStatus} key={key} value={key}>{item?.displayName}</option>
                                )
                            })}
                        </select>
                    </div>
                </div>
                <div className='d-flex align-items-center mt-3'>
                    <div className='client-po-id text-right mr-2'>White Label:</div>
                    <div className=''>
                        <select className='w-250 form-select inputborder font11' value={selectedWhiteLabel} onChange={(e) => { onChangeOfWhiteLable(e) }}>
                            <option value="">Select</option>
                            {(!!filteredWhiteLabel && filteredWhiteLabel?.length > 0) && filteredWhiteLabel.map((itm, index) => {
                                return (
                                    <option key={index} value={itm.primaryDomain}>{itm.primaryDomain}</option>
                                )
                            })}
                        </select>
                    </div>
                </div>
            </div>
            {!!selectedLicence ?
                <div className="thead-fixed">
                    <table className="table table-bordered table-strip w-100 mb-30 new-data-asc-desc">
                        <thead>
                            <tr className="thead-dard-bg">
                                <th className="srn-width">Sr</th>
                                <th className="">Service Type</th>
                                <th className="">Service Name</th>
                                <th className="">Api Url</th>
                                <th className="">Status</th>
                                <th className="">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!!updatedServiceList && updatedServiceList?.length ? updatedServiceList?.map((item, index) => {
                                return (
                                    <ServiceWatchTr
                                        index={index + 1}
                                        item={item}
                                        selectedLicence={selectedLicence}
                                        selectDomain={selectDomain}
                                        regetservices={regetservices}
                                        servicesList={servicesList}
                                    />
                                )
                            }) : <NoDataError colspn={5} />}
                        </tbody>
                    </table>
                </div>

                :
                <div>
                    <div onClick={() => { navigate('/home'); sessionStorage.setItem("selectedId", JSON.stringify(1)) }} className='container-fluid mt-3 font-bold text-center font-size-16'>
                        View Dashboard
                    </div>
                </div>
            }
        </div>
    )
}

export default ServiceWatch